import React, { useState, useEffect, useRef } from 'react';
import '@/pages/intelligence/assets/scss/MarketProfile/TabDetails/index.scss';

import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import { getLocale, history, useIntl } from 'umi';

import Overview from './Overview/index';
import Insights from './Insights/index';
import Stats from './Stats';
import StatsNew from './StatsNew/Page';
import Demographics from './Demographics/index';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
// import { changeURLStatic } from '@/pages/intelligence/pages/MarketProfile/_util';
import GuideGenreMarketProfile, {
  GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES,
} from '@intelligence/components/UserGuide/GenreMarketProfile';
import nameMap from '@/pages/dashboard/components/MapEchart/_config/nameMap.json';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

const { Body, Content } = Layout;

export default function MarketTabDetails(props: any) {
  const [activeId, setActiveId] = useState(props?.match?.params?.tab || 'Overview');
  const { marketName, marketNameEn, pageId, isAnnie, dimension, dateRange, dateType } = history.location.query || {};
  const [segment, setSegment] = useState('mobile');
  // const [segment, setSegment] = useState('pc');
  const { formatMessage } = useIntl();
  const isEN = getLocale() === 'en-US';
  // 增加纯国家列表以用来简称匹配全称用
  const [NameMapFormBack, setNameMapFormBack] = useState<any>([]);
  // 获取全局国家地区数据
  const { regionOptions } = useMarketFilterApi({ filterType: 'rpd' });

  useEffect(() => {
    const allMarkets = regionOptions?.map((area: any) => area.country_set).flat() || [];
    const nameMap = {} as any;
    allMarkets?.forEach((country: any) => {
      nameMap[country.country_name_en] = country.country_name_ch;
    });
    setNameMapFormBack(nameMap);
  }, [regionOptions]);

  const jumpStat = (url: any) => {
    history.push(url);
    setActiveId('Stats');
  };
  const scrollBody = useRef(null);

  const tabs = [
    {
      id: 'Overview',
      label: formatMessage({ id: 'dbi_overview' }),
      component: (
        <Overview
          changeSegment={(value: string) => setSegment(value)}
          pageId={pageId}
          marketNameEn={marketNameEn}
          marketName={marketName}
          segment={segment}
          activeId={activeId}
          jumpStat={jumpStat}
          scrollBody={scrollBody}
          NameMapFormBack={NameMapFormBack}
        />
      ),
    },
    {
      id: 'Insights',
      label: formatMessage({ id: 'dbi_insights' }),
      component: (
        <Insights
          marketName={marketName}
          marketNameEn={marketNameEn}
          pageId={pageId}
          segment={segment}
          activeId={activeId}
          changeSegment={(value: string) => setSegment(value)}
          setActiveId={setActiveId}
          jumpStat={jumpStat}
          scrollBody={scrollBody}
        />
      ),
    },
    {
      id: 'Stats',
      label: formatMessage({ id: 'dbi_stats' }),
      component: (
        segment !== 'mobile'
          ? <Stats
            changeSegment={(value: string) => setSegment(value)}
            setActiveId={setActiveId}
            scrollBody={scrollBody}
            marketName={marketName}
            marketNameEn={marketNameEn}
            pageId={pageId}
            segment={segment}
            activeId={activeId}
            regionOptions={regionOptions}
          />
          : <StatsNew
            entityType={segment}
            activeId={activeId}
            pageId={pageId}
            changeLeftSegment={(value: string) => setSegment(value)}
            marketName={marketName}
            marketNameEn={marketNameEn}
            genreSource={!!isAnnie ? 'appannie' : 'iegg'}
            defaultDimension={dimension}
            defaultDateRange={dateRange}
            defaultDateType={dateType}
          />
      ),
    },
    {
      id: 'Demographics',
      label: formatMessage({ id: 'dbi_demographics' }),
      className: GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES.ELEMENT5,
      component: <Demographics />,
    },
  ];

  // 调用打点
  const postLog = (activePageName: string) => {
    let info = 'marketProfileOverview';
    switch (activePageName) {
      case 'Insights':
        info = 'marketProfileInsights';
        break;
      // Stats改用子页面打点，所以这里直接return
      case 'Stats':
        return;
      case 'Demographics':
        info = 'marketProfileDemographics';
        break;
      default:
        info = 'marketProfileOverview';
        break;
    }
    buriedPointPage(dbiPageLogMes[info]);
  };

  useEffect(() => {
    if (!activeId) return;
    // 当tab id设置完成后再打点
    postLog(activeId);
  }, [activeId]);

  const onActive = (tab: { id: any }) => {
    setActiveId(tab.id);
    const isAnnie: any = history.location.query?.isAnnie;
    history.replace(
      `/intelligence/marketProfile/${
        tab.id
      }/detail?marketName=${marketName}&marketNameEn=${marketNameEn}&pageId=${pageId}&segment=${segment}${
        isAnnie ? `&isAnnie=${isAnnie}` : ''
      }`,
    );
  };
  return (
    <Content className="dbi-market-tabdetails" ref={scrollBody}>
      <Content.Header
        className="dbi-header contentHead-normal"
        title={isEN ? marketName : NameMapFormBack[marketName] || marketName}
        showBackButton
        onBackButtonClick={() => {
          // window.history.back();
          history.replace(`/intelligence/marketProfile`);
        }}
      >
        <div className="header-tab">
          <Tabs
            ceiling
            newMarkIdsMappingKey="MarketProfileDetails"
            tabs={tabs}
            animated={false}
            activeId={activeId}
            onActive={onActive}
          />
        </div>
      </Content.Header>
      <Content.Body full>
        <MarqueeBanner />
        {tabs.map((e) => {
          return <div key={e.id}>{e.id == activeId ? e.component : ''}</div>;
        })}
      </Content.Body>
      <GuideGenreMarketProfile />
    </Content>
  );
}
